class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility(); 
  }

  setHeaderCartIconAccessibility() { 
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if(document.querySelector('#tidio-chat')){
      document.querySelector('#tidio-chat').style.display = "none"
    }
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
    if(document.querySelector('#tidio-chat') != null){
      document.querySelector('#tidio-chat').style.display = "none"
    }

    if(document.querySelector('.giraffly_PCPreview_BOX') != null){
      document.querySelector('.giraffly_PCPreview_BOX').style.display = "none"
    }

    if(document.querySelector('#fc_widget') != null){
      document.querySelector('#fc_widget').style.display = "none"
    }
    if($("cart-drawer-items").hasClass("is-empty")){
      if($("#product-grid_empty_cart").hasClass("slick-initialized")){
        $("#product-grid_empty_cart").slick("resize");     
        $('.cart-drawer__collection').slick("resize"); 
      }else{        
        $("#product-grid_empty_cart").slick({
          dots: true, // Afficher les points
          arrows: true, // Afficher les flèches
          slidesToShow: 1, // Afficher un seul élément par diapositive
          slidesToScroll: 1, // Faire défiler un seul élément à la fois
          prevArrow:"<button type='button' class='slick-prev pull-left'><svg xmlns='http://www.w3.org/2000/svg' width='7' height='14' viewBox='0 0 7 14' fill='none'> <path d='M0.701829 6.90389C0.701829 7.08352 0.761734 7.25317 0.891528 7.39287L5.69391 12.8814C5.96348 13.2008 6.43273 13.2307 6.74224 12.9513C7.05175 12.6719 7.09169 12.2128 6.81213 11.9035L2.44906 6.90389L6.81213 1.90431C7.0817 1.59495 7.05175 1.11595 6.74224 0.846514C6.43273 0.577075 5.95349 0.607013 5.68392 0.916368L0.881544 6.41491C0.761734 6.55462 0.691845 6.73425 0.691845 6.90389H0.701829Z' fill='black'/> </svg></button>",
          nextArrow:"<button type='button' class='slick-next pull-right'><svg xmlns='http://www.w3.org/2000/svg' width='7' height='14' viewBox='0 0 7 14' fill='none'> <path d='M6.29817 6.90389C6.29817 7.08352 6.23827 7.25317 6.10847 7.39287L1.30609 12.8814C1.03652 13.2008 0.567267 13.2307 0.257758 12.9513C-0.0517502 12.6719 -0.0916868 12.2128 0.187869 11.9035L4.55094 6.90389L0.187869 1.90431C-0.0817027 1.59495 -0.0517502 1.11595 0.257758 0.846514C0.567267 0.577075 1.04651 0.607013 1.31608 0.916368L6.11846 6.41491C6.23827 6.55462 6.30816 6.73425 6.30816 6.90389H6.29817Z' fill='black'/> </svg></button>"
        });
        $('.cart-drawer__collection').slick({
          slidesToShow: 2.5, // Affiche 2 éléments complets et la moitié du 3ème
          slidesToScroll: 1, 
          dots:false,
          infinite:false,
          arrows:false,
          centerMode: false // Désactive le mode centré
        });
        $('.cart-drawer__collection').slick("resize"); 
      }
    }
    $("#product_reviews_cart").slick({
      dots: true,      
      arrows: true, 
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow:"<button type='button' class='slick-prev pull-left'><svg xmlns='http://www.w3.org/2000/svg' width='12' height='15' viewBox='0 0 7 14' fill='none'> <path d='M0.701829 6.90389C0.701829 7.08352 0.761734 7.25317 0.891528 7.39287L5.69391 12.8814C5.96348 13.2008 6.43273 13.2307 6.74224 12.9513C7.05175 12.6719 7.09169 12.2128 6.81213 11.9035L2.44906 6.90389L6.81213 1.90431C7.0817 1.59495 7.05175 1.11595 6.74224 0.846514C6.43273 0.577075 5.95349 0.607013 5.68392 0.916368L0.881544 6.41491C0.761734 6.55462 0.691845 6.73425 0.691845 6.90389H0.701829Z' fill='black'/> </svg></button>",
      nextArrow:"<button type='button' class='slick-next pull-right'><svg xmlns='http://www.w3.org/2000/svg' width='12' height='15' viewBox='0 0 7 14' fill='none'> <path d='M6.29817 6.90389C6.29817 7.08352 6.23827 7.25317 6.10847 7.39287L1.30609 12.8814C1.03652 13.2008 0.567267 13.2307 0.257758 12.9513C-0.0517502 12.6719 -0.0916868 12.2128 0.187869 11.9035L4.55094 6.90389L0.187869 1.90431C-0.0817027 1.59495 -0.0517502 1.11595 0.257758 0.846514C0.567267 0.577075 1.04651 0.607013 1.31608 0.916368L6.11846 6.41491C6.23827 6.55462 6.30816 6.73425 6.30816 6.90389H6.29817Z' fill='black'/> </svg></button>"
        
    });
    $("slider-component#Slider-cart").slick({
      dots: true,      
      arrows: false,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000   
    });
  }

  close() {
    if(document.querySelector('#tidio-chat') != null){
      document.querySelector('#tidio-chat').style.display = "block"
    }
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    if(document.querySelector('#tidio-chat') != null){
      document.querySelector('#tidio-chat').style.display = "block"
    }
    if(document.querySelector('#fc_widget')!= null ){
      document.querySelector('#fc_widget').style.display = "block"
    }

    if(document.querySelector('.giraffly_PCPreview_BOX') != null){
      document.querySelector('.giraffly_PCPreview_BOX').style.display = "block"
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open(); 
    });
    if (typeof initUpsellSlider === "function") { 
      initUpsellSlider();
      
    }
    
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
  
}

customElements.define('cart-drawer-items', CartDrawerItems);
